import { render, staticRenderFns } from "./SolanJournalsT.vue?vue&type=template&id=3e60515e&scoped=true&"
import script from "./SolanJournalsT.vue?vue&type=script&lang=ts&"
export * from "./SolanJournalsT.vue?vue&type=script&lang=ts&"
import style0 from "./SolanJournalsT.vue?vue&type=style&index=0&id=3e60515e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e60515e",
  null
  
)

export default component.exports